const filtersData = [
  {
    label: 'ALL',
    name: 'All',
    total: 0,
  },
  {
    label: 'NEW',
    name: 'PROSPECTIVE',
    total: 0,
  },
  {
    label: 'ACTIVE',
    name: 'ACTIVE',
    total: 0,
  },
  {
    label: 'HIRED',
    name: 'HIRED',
    total: 0,
  },
  {
    label: 'REJECTED',
    name: 'REJECTED',
    total: 0,
  },
];

export { filtersData };
